import React from 'react';

import {
  withScriptjs,
  withGoogleMap,
 // GoogleMapLoader,
  GoogleMap,
  Marker,
  } from 'react-google-maps';

const replaceAll = function(str1, str2, ignore)
{
  return this.replace(new RegExp(str1.replace(/([/,!\\^${}[\]().*+?|<>\-&])/g,"\\$&"),(ignore?"gi":"g")),(typeof(str2)==="string")?str2.replace(/\$/g,"$$$$"):str2);
}

const invalid = Symbol.for('invalid');

const GoogleMapRenderer = withScriptjs(withGoogleMap(props => (
      <GoogleMap
          defaultZoom={10}
          ref={props.onMapLoad}
          defaultCenter={props.defaultCenter}
          onClick={props.onClick}
          defaultOptions={{
            mapTypeControl: false,
            streetViewControl: false
        }}>
        {props.markerElement}
      </GoogleMap>
    )));

class GeoField extends React.Component {
  constructor(props) {
    super(props);
    const defaultValue = typeof this.props.default === 'function' ?
       this.props.default() : this.props.default;

    const [lng, lat] = this.props.value || defaultValue || [undefined, undefined];

    const lngS = lng && lng.toString ? lng.toString() : lng;
    const latS = lat && lat.toString ? lat.toString() : lat;

    this.state = {
      lng: lngS,
      lat: latS,
      oldLng: lngS,
      oldLat: latS
    };
  }


  componentDidMount() {
    this.props.onChange(this.state.isValid || !this.props.required ? this.state.value : invalid);
  }

  parseEnteredValue(val = '') {


    if (typeof val !== 'string') {
      return false;
    }

    if (val.trim() === '') {
      return undefined;
    }

    let stringValue = val.trim().replace(',', '.').replace(/[^0-9.-]/g, '');

    const replaceButFirst = (strOriginal, strToReplace, shouldBeFirst = false) => {
      const n = strOriginal.indexOf(strToReplace);
      const firstPart = strOriginal.substring(0, n !== 0 && shouldBeFirst ? n : n + 1);
      let tempString = strOriginal.substring(n + 1);
      tempString = replaceAll(tempString, strToReplace, '');
      return firstPart + tempString;
    }

    stringValue = replaceButFirst(stringValue, '-', true);
    stringValue = replaceButFirst(stringValue, '.');


    //const parsed = parseFloat(stringValue);

    //return parsed === parsed ? stringValue : false;
    return stringValue;
  }

  handleLatChange(event) {
    const lat = this.parseEnteredValue(event.target.value);
    if (lat === false) return;

    this.setState({
      lat,
      oldLat: lat || this.state.lat
    });

    const newCoords = [parseFloat(this.state.lng), parseFloat(lat)];

    this.panIfNeed(newCoords);
    this.props.onChange(newCoords);
  }

  handleLngChange(event) {
    const lng = this.parseEnteredValue(event.target.value);

    if (lng === false) return;

    this.setState({ lng });

    this.setState({
      lng,
      oldLng: lng || this.state.lng
    });

    const newCoords = [parseFloat(lng), parseFloat(this.state.lat)];

    this.panIfNeed(newCoords);
    this.props.onChange(newCoords);

  }

  panIfNeed([lng, lat]) {

    console.log('pin', this._map);

    if (!this._map) return;
    if (!lat || !lng) return;

    const bounds = this._map.getBounds();

    if (bounds) {
      const NorthEast = bounds.getNorthEast();
      const SouthWest = bounds.getSouthWest();

      const north = NorthEast.lat();
      const east = NorthEast.lng();
      const south = SouthWest.lat();
      const west = SouthWest.lng();

      const inBounds = (lat > south && lat < north) && (lng > west && lng < east);

      if (!inBounds) {
        this._map.panTo({lat, lng});
      }
    }
  }

  handleMapClick(event) {
    const lat = event.latLng.lat().toString();
    const lng = event.latLng.lng().toString();
    this.setState({
      lat,
      lng,
      oldLat: lat,
      oldLng: lng
    });
    this.props.onChange([lng, lat]);
  }

  render() {
    const __ = this.props.translate || (v => v);

    const {readOnly = false, currentData, name} = this.props;

    const center =  {
      lat: parseFloat(this.state.lat || this.state.oldLat || "41.8919300"),
      lng: parseFloat(this.state.lng || this.state.oldLng || "12.5113300")
    }

    let {lat, lng} = center;
    if (readOnly) {
      const cdv = currentData && currentData.get && currentData.get(name);
      if (cdv) {
        lat = cdv.get(1);
        lng = cdv.get(0);
      }
    }



    const markerElement = lat && lng ? (
      <Marker
          key='me'
          position={{lat, lng}}
          title='me'  />
      ) : null;



    const unparse = val => val ? val.replace(',','.') : undefined;

    return (
      <div className={`form-group row ${this.props.className}`}>
        <label className="col-sm-3 form-control-label">
          {__(this.props.title)}
        </label>
        <div className='col-sm-9 row'>
          <div className='col-sm-6'>
            <div className="input-group">
              <span className="input-group-addon" id="sizing-addon2">Lat</span>
              <input type="text"
                     disabled={readOnly}
                     value={unparse(this.state.lat)}
                     onChange={this.handleLatChange.bind(this)}
                     placeholder={__(this.props.placeholder)}
                     className="form-control" />
            </div>
          </div>
          <div className='col-sm-6'>
            <div className="input-group">
              <span className="input-group-addon" id="sizing-addon2">Long</span>
              <input type="text"
                     disabled={readOnly}
                     value={unparse(this.state.lng)}
                     onChange={this.handleLngChange.bind(this)}
                     placeholder={__(this.props.placeholder)}
                     className="form-control" />
              </div>
            </div>
                  <GoogleMapRenderer
                    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyAKg1jX1gS4mYZQw2v2fwtaUfwzW02CHJM"
                    defaultCenter={center}
                    onMapLoad={ref => this._map = ref}
                    loadingElement={<div style={{ height: `100%` }} />}
                    containerElement={<div style={{ height: '300px' }} />}
                    mapElement={<div style={{ height: `100%` }} />}
                    onClick={e => this.handleMapClick(e)}
                    markerElement={markerElement}
                  />

        </div>
      </div>
    );
  }
}

export default GeoField;
